exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".home {\n  background-color: #e8e8e8;\n  min-height: 100vh;\n}\n.home-canteen-card {\n  min-height: 200px;\n}\n", ""]);
